// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"251":"928c0203","620":"102ba777"}[chunkId] + ".css";
};